// extracted by mini-css-extract-plugin
export var active = "_45-7";
export var container = "_45-0";
export var evenWidth = "_45-4";
export var large = "_45-5";
export var outlet = "_45-8";
export var slide = "_45-2";
export var small = "_45-6";
export var tab = "_45-3";
export var tabs = "_45-1";